'use strict';

var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var slicedToArray = require('../../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Divider = require('../../DataDisplay/Divider/Divider.js');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var LinearProgress = require('../../Feedback/Progress/LinearProgress.js');
var TruncateText = require('../../../utils/TruncateText.js');
var Tooltip = require('../../DataDisplay/Tooltips/Tooltip.js');
var CardHeader$1 = require('../../../node_modules/@material-ui/core/esm/CardHeader/CardHeader.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var variants = {
  small: {
    title: 'subtitle1',
    avatar: {
      marginRight: -8,
      position: 'relative',
      top: 1.4
    },
    padding: {
      padding: '8px 16px',
      height: 48,
      boxSizing: 'border-box'
    },
    blur: {
      backgroundColor: '#ffffff',
      position: 'absolute',
      zIndex: 20,
      top: 48,
      left: 0,
      opacity: 0.93,
      height: 'calc(100% - 48px)',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0 0 8px 8px'
    }
  },
  medium: {
    title: 'h3',
    avatar: {
      marginRight: -8,
      position: 'relative',
      top: 1.4
    },
    action: {
      marginRight: -4,
      marginTop: 0
    },
    padding: {
      padding: '12px 16px',
      height: 60,
      boxSizing: 'border-box'
    },
    blur: {
      backgroundColor: '#ffffff',
      position: 'absolute',
      zIndex: 20,
      top: 60,
      left: 0,
      opacity: 0.93,
      height: 'calc(100% - 60px)',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0 0 8px 8px'
    }
  },
  large: {
    title: 'h5',
    avatar: {
      marginRight: -8,
      position: 'relative',
      top: 1.4
    },
    action: {
      marginRight: -4,
      marginTop: 0
    },
    padding: {
      padding: '16px',
      height: 72,
      boxSizing: 'border-box'
    },
    blur: {
      backgroundColor: '#ffffff',
      position: 'absolute',
      zIndex: 20,
      top: 72,
      left: 0,
      opacity: 0.93,
      height: 'calc(100% - 72px)',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '0 0 8px 8px'
    }
  }
};

var CardHeader = function CardHeader(_ref) {
  var title = _ref.title,
      icon = _ref.icon,
      variant = _ref.variant,
      action = _ref.action,
      showDivider = _ref.showDivider,
      loading = _ref.loading,
      maxLines = _ref.maxLines,
      disableTypography = _ref.disableTypography,
      noPadding = _ref.noPadding,
      wordBreak = _ref.wordBreak,
      props = objectWithoutProperties(_ref, ["title", "icon", "variant", "action", "showDivider", "loading", "maxLines", "disableTypography", "noPadding", "wordBreak"]);

  var _useState = React.useState(true),
      _useState2 = slicedToArray(_useState, 2),
      tooltipDisabled = _useState2[0],
      setTooltipDisabled = _useState2[1];

  return React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(CardHeader$1["default"], _objectSpread({
    style: noPadding ? {} : variants[variant].padding,
    avatar: icon && React__default["default"].cloneElement(icon, {
      style: variants[variant].avatar
    }),
    disableTypography: true,
    title: disableTypography ? title : React__default["default"].createElement(Tooltip, {
      title: title,
      disableHoverListener: tooltipDisabled,
      placement: 'top-start',
      enterDelay: 300
    }, React__default["default"].createElement(Typography, {
      variant: variants[variant].title
    }, React__default["default"].createElement(TruncateText, {
      wordBreak: wordBreak,
      maxLines: maxLines,
      // @ts-ignore
      onTruncate: function onTruncate(truncated) {
        setTooltipDisabled(!truncated);
      }
    }, title))),
    action: action
  }, props)), showDivider && React__default["default"].createElement(Divider, null), loading && React__default["default"].createElement(React.Fragment, null, React__default["default"].createElement(LinearProgress, {
    style: {
      position: 'relative',
      zIndex: 21
    }
  }), React__default["default"].createElement("div", {
    style: variants[variant].blur
  })));
};
CardHeader.defaultProps = {
  variant: 'small',
  showDivider: true,
  loading: false,
  maxLines: 1,
  noPadding: false,
  wordBreak: 'break-all'
};

module.exports = CardHeader;
